import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { HomePage } from '../../pages/home/home';
import { BasketPage } from '../../pages/basket/basket';
import { AccountPage } from '../../pages/account/account';
import { ContactPage } from '../../pages/contact/contact';
import { CategoryPage } from '../../pages/category/category';

import { DataProvider } from '../data/data';
import { CategoryProvider } from '../category/category';
import { LoginProvider } from '../login/login';
import { CompanyConfigProvider } from '../company-config/company-config';

@Injectable()
export class NavigationListProvider {

  public pages: Array<{ title: string, component?: any, params: any, color: string, function?: () => void }>;

  private loadingPages = false;

  constructor(private categoryProvider: CategoryProvider,
    private loginProvider: LoginProvider,
    private companyConfigProvider: CompanyConfigProvider) {
    this.pages = [];
  }

  /**
  * Adds the category pages to the navigation list.
  */
  public async loadCategoryListItems() {
    // Remove pages
    this.pages = this.pages.filter(x => false);

    var categories = await this.categoryProvider.getCategories();
    console.warn(categories);

    // Add HomePage
    this.pages.push({ title: 'HOME.TITLE', component: HomePage, params: {}, color: "dark" });
    // Add Category Pages
    var i = 1;
    categories.forEach(x => {
      this.pages.splice(i, 0, { title: x.name, component: CategoryPage, params: { "categoryId": x.uuid }, color: "primary" });
      i++;
    });
    // Add FavoritePage
    this.pages.push({ title: 'FAVORITES.TITLE', component: CategoryPage, params: { "favorites": true }, color: "dark" });
    if (await this.companyConfigProvider.canSubmitOrder()) {
      // Add BasketPage
      this.pages.push({ title: 'BASKET.TITLE', component: BasketPage, params: {}, color: "dark" });
    }
    // Add AccountPage if not logged in
    if (!this.loginProvider.isAnonymousSession) this.pages.push({ title: 'ACCOUNT.TITLE', component: AccountPage, params: {}, color: "dark" });
    // Add ContactPage
    this.pages.push({ title: 'CONTACT.TITLE', component: ContactPage, params: {}, color: "dark" });
    // Add Login Button if not logged in
    if (this.loginProvider.isAnonymousSession) this.pages.push({ title: 'LOGIN.TITLE', params: {}, color: "dark", function: () => { this.loginProvider.quitAnonymousSession() } });

  }
}


// WEBPACK FOOTER //
// ./src/providers/navigation-list/navigation-list.ts